import { DxIcon } from "../../dx/ui/icons";

const JA_MESSAGES = {
  title: "注意",
  body: "チェックイン2日前の15:00まで、部屋番号を変更させていただく場合があります。",
};
export type RoomChangeNoticeMessages = typeof JA_MESSAGES;

/**
 * 部屋タイプ予約時の注記（Figma: Stay事業 Alert）。
 * 「チェックイン2日前まで部屋番号が変更になる可能性」を伝える。
 */
export function RoomChangeNotice({
  messages = JA_MESSAGES,
}: {
  messages?: RoomChangeNoticeMessages;
} = {}) {
  return (
    // デザインシステム過渡期につき色は暫定でベタ書き。次Qでトークン化予定。
    // Figma(feedback/warning): 背景 #f2efd6 (warning-subtle) / 文字・アイコン #6f6829 (warning-text)。
    // アイコンは DxIcon のマスク着色で currentColor 化。
    <div className="font-notojp flex items-start gap-[12px] rounded-[4px] bg-[#f2efd6] p-[12px] text-[#6f6829]">
      <DxIcon src="/i/dx/warn.svg" />
      <div className="flex flex-col gap-[4px] text-[14px] leading-[1.6]">
        <p className="font-bold">{messages.title}</p>
        <p>{messages.body}</p>
      </div>
    </div>
  );
}
